// extracted by mini-css-extract-plugin
export default {"layout":"RecordCompare_layout__bRNRT","card-view":"RecordCompare_card-view__fxiiV","message":"RecordCompare_message__9ejD9"};